import React, { useRef, useState } from 'react';
import { useSelector } from 'umi';

import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { commonDateDefault } from '../../utils/dateUtils';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const firstWordUpper = (str) => {
  if (!str) return str;
  const firstLetter = str.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = str.slice(1);
  return firstLetterCap + remainingLetters === 'Date' ? 'Day' : firstLetterCap + remainingLetters;
};

// 筛选器路径
const FILTER_PATH = 'engagement/active/activeUsers';

const ActiveUsersFilter = (props: any) => {
  const { filterConfirm, filterReset, buttonLogConfig, setFilterLoading, filterInit,
    openSticky = false, children, isHaveFilterSave, timeZone = 0, config } = props;
  const { dateOffSet } = config || {};
  // daily筛选器继承逻辑
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const { seasonInfo } = useSelector((state: any) => 
    // 初始可能为undefied,在此加兜底
    ({
      seasonInfo: state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] },
    })
  );

  // 设置inputList
  // 注：inputList 是筛选器的「初始配置」（typeList / 默认日期 / extraShortcut 等），
  // 应在挂载时只生成一次。即使 seasonInfo 后续异步更新，也不应重新生成 inputList，
  // 否则会触发 Filter 重新初始化、冲掉用户已选/已确认的值。
  // 与 newFilter / pcConsoleDailyFilter 等同类筛选器保持一致约定，使用 useState 而非 useMemo。
  const [inputList] = useState([commonDateDefault(timeZone, seasonInfo, undefined, dateOffSet)]);

  const handleConfirm = (value: any) => {
    filterValueRef.current = value;
    filterConfirm?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value);
  };

  const handleReset = (value: any) => {
    filterValueRef.current = value;
    filterReset?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, value, true);
  };

  const handleInit = (value: any) => {
    filterValueRef.current = value;
    filterInit?.({
      ...value,
      rangeTime: [
        value?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'),
        value?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')
      ],
      timeType: firstWordUpper(value?.rangeTime?.type),
    });
    setFilterLoading(false);
  };

  // const handleChange = (key: string, value: any) => {
  //   if (key === 'rangeTime') {
  //     filterValueRef.current = {
  //       ...filterValueRef.current,
  //       [key]: {
  //         type: value.type,
  //         value: value.value,
  //       },
  //     };
  //   }
  // };

  return (
    <Filter
      config={props.config}
      openSticky={openSticky}
      path={FILTER_PATH}
      value={filterValueRef.current}
      latestDateType={''}
      inputList={inputList}
      onInit={handleInit}
      onConfirm={handleConfirm}
      onReset={handleReset}
      isHaveFilterSave={isHaveFilterSave}
    >
      {children}
    </Filter>
  );
};

export default ActiveUsersFilter;
